export const GET_USER_NOTIFICATIONS_REQUESTED =
  "GET_USER_NOTIFICATIONS_REQUESTED"
export const GET_USER_NOTIFICATIONS_SUCCESSFUL =
  "GET_USER_NOTIFICATIONS_SUCCESSFUL"
export const GET_USER_NOTIFICATIONS_FAILED = "GET_USER_NOTIFICATIONS_FAILED"
export const SET_USER_NOTIFICATIONS = "SET_USER_NOTIFICATIONS"

export const COURSE_ENROLLMENT_REQUESTED = "COURSE_ENROLLMENT_REQUESTED"
export const COURSE_ENROLLMENT_SUCCESSFUL = "COURSE_ENROLLMENT_SUCCESSFUL"
export const COURSE_ENROLLMENT_FAILED = "COURSE_ENROLLMENT_FAILED"

export const COURSE_BUNDLE_ENROLLMENT_REQUESTED =
  "COURSE_BUNDLE_ENROLLMENT_REQUESTED"
export const COURSE_BUNDLE_ENROLLMENT_SUCCESSFUL =
  "COURSE_BUNDLE_ENROLLMENT_SUCCESSFUL"
export const COURSE_BUNDLE_ENROLLMENT_FAILED = "COURSE_BUNDLE_ENROLLMENT_FAILED"

export const TOGGLE_RESPONSE_MODAL = "TOGGLE_RESPONSE_MODAL"
export const UNTOGGLE_RESPONSE_MODAL = "UNTOGGLE_RESPONSE_MODAL"

export const GET_USER_PROFILE_REQUESTED = "GET_USER_PROFILE_REQUESTED"
export const GET_USER_PROFILE_SUCCESSFUL = "GET_USER_PROFILE_SUCCESSFUL"
export const GET_USER_PROFILE_FAILED = "GET_USER_PROFILE_FAILED"

export const SET_USER_PROFILE = "SET_USER_PROFILE"
export const GET_USER_ENROLLMENTS_REQUESTED = "GET_USER_ENROLLMENTS_REQUESTED"
export const GET_USER_ENROLLMENTS_SUCCESSFUL = "GET_USER_ENROLLMENTS_SUCCESSFUL"
export const GET_USER_ENROLLMENTS_FAILED = "GET_USER_ENROLLMENTS_FAILED"

export const GET_USER_CERTIFICATES_REQUESTED = "GET_USER_CERTIFICATES_REQUESTED"
export const GET_USER_CERTIFICATES_SUCCESSFUL =
  "GET_USER_CERTIFICATES_SUCCESSFUL"
export const GET_USER_CERTIFICATES_FAILED = "GET_USER_CERTIFICATES_FAILED"

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED"

export const GET_LAW_SCHOOLS_REQUEST = "GET_LAW_SCHOOLS_REQUEST"
export const GET_LAW_SCHOOLS_SUCCESS = "GET_LAW_SCHOOLS_SUCCESS"
export const GET_LAW_SCHOOLS_FAILED = "GET_LAW_SCHOOLS_FAILED"

export const GET_MCLE_PROFILE_REQUEST = "GET_MCLE_PROFILE_REQUEST"
export const GET_MCLE_PROFILE_SUCCESS = "GET_MCLE_PROFILE_SUCCESS"
export const GET_MCLE_PROFILE_FAILED = "GET_MCLE_PROFILE_FAILED"
export const SET_MCLE_USER_PROFILE = "SET_USER_MCLE_PROFILE"
export const UPDATE_MCLE_PROFILE_REQUEST = "UPDATE_MCLE_PROFILE_REQUEST"
export const UPDATE_MCLE_PROFILE_SUCCESS = "UPDATE_MCLE_PROFILE_SUCCESS"
export const UPDATE_MCLE_PROFILE_FAILED = "UPDATE_MCLE_PROFILE_FAILED"

export const START_COURSE_REQUESTED = "START_COURSE_REQUESTED"
export const START_COURSE_SUCCESSFUL = "START_COURSE_SUCCESSFUL"
export const START_COURSE_FAILED = "START_COURSE_FAILED"

export const END_COURSE_REQUESTED = "END_COURSE_REQUESTED"
export const END_COURSE_SUCCESSFUL = "END_COURSE_SUCCESSFUL"
export const END_COURSE_FAILED = "END_COURSE_FAILED"

export const GET_USER_COURSEWARES_REQUESTED = "GET_USER_COURSEWARES_REQUESTED"
export const GET_USER_COURSEWARES_SUCCESSFUL = "GET_USER_COURSEWARES_SUCCESSFUL"
export const GET_USER_COURSEWARES_FAILED = "GET_USER_COURSEWARES_FAILED"

export const GET_ENROLLMENTS_REQUESTED = "GET_ENROLLMENTS_REQUESTED"
export const GET_ENROLLMENTS_SUCCESSFUL = "GET_ENROLLMENTS_SUCCESSFUL"
export const GET_ENROLLMENTS_FAILED = "GET_ENROLLMENTS_FAILED"

export const PATCH_NOTES_REQUESTED = "PATCH_NOTES_REQUESTED"
export const PATCH_NOTES_SUCCESSFUL = "PATCH_NOTES_SUCCESSFUL"
export const PATCH_NOTES_FAILED = "PATCH_NOTES_FAILED"

export const SHOW_TOAST = "SHOW_TOAST"

export const COMPLETE_COURSEWARE_REQUESTED = "COMPLETE_COURSEWARE_REQUESTED"
export const COMPLETE_COURSEWARE_SUCCESSFUL = "COMPLETE_COURSEWARE_SUCCESSFUL"
export const COMPLETE_COURSEWARE_FAILED = "COMPLETE_COURSEWARE_FAILED"

export const SET_COURSEWARE_PROGRESS_REQUESTED =
  "SET_COURSEWARE_PROGRESS_REQUESTED"
export const SET_COURSEWARE_PROGRESS_SUCCESSFUL =
  "SET_COURSEWARE_PROGRESS_SUCCESSFUL"
export const SET_COURSEWARE_PROGRESS_FAILED = "SET_COURSEWARE_PROGRESS_FAILED"

export const GET_KYC_ID_TEMPLATE_REQUESTED = "GET_KYC_ID_TEMPLATE_REQUESTED"
export const GET_KYC_ID_TEMPLATE_SUCCESSFUL = "GET_KYC_ID_TEMPLATE_SUCCESSFUL"
export const GET_KYC_ID_TEMPLATE_FAILED = "GET_KYC_ID_TEMPLATE_FAILED"

export const UPLOAD_KYC_ID_TEMPLATE_REQUESTED =
  "UPLOAD_KYC_ID_TEMPLATE_REQUESTED"
export const UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL =
  "UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL"
export const UPLOAD_KYC_ID_TEMPLATE_FAILED = "UPLOAD_KYC_ID_TEMPLATE_FAILED"

export const SUBMIT_MANUAL_KYC_REQUESTED = "SUBMIT_MANUAL_KYC_REQUESTED"
export const SUBMIT_MANUAL_KYC_SUCCESSFUL = "SUBMIT_MANUAL_KYC_SUCCESSFUL"
export const SUBMIT_MANUAL_KYC_FAILED = "SUBMIT_MANUAL_KYC_FAILED"

export const SET_KYC_VERIFY_RETRIES = "SET_KYC_VERIFY_RETRIES"

export const SET_USER_ERROR = "SET_USER_ERROR"

export const START_EXAM_REQUESTED = "START_EXAM_REQUESTED"
export const START_EXAM_SUCCESSFUL = "START_EXAM_SUCCESSFUL"
export const START_EXAM_FAILED = "START_EXAM_FAILED"

export const SUBMIT_ANSWER_REQUESTED = "SUBMIT_ANSWER_REQUESTED"
export const SUBMIT_ANSWER_SUCCESSFUL = "SUBMIT_ANSWER_SUCCESSFUL"
export const SUBMIT_ANSWER_FAILED = "SUBMIT_ANSWER_FAILED"

export const GET_EXAM_DETAILS_REQUESTED = "GET_EXAM_DETAILS_REQUESTED"
export const GET_EXAM_DETAILS_SUCCESSFUL = "GET_EXAM_DETAILS_SUCCESSFUL"
export const GET_EXAM_DETAILS_FAILED = "GET_EXAM_DETAILS_FAILED"

export const GET_CLASS_SCHEDULE_REQUESTED = "GET_CLASS_SCHEDULE_REQUESTED"
export const GET_CLASS_SCHEDULE_SUCCESSFUL = "GET_CLASS_SCHEDULE_SUCCESSFUL"
export const GET_CLASS_SCHEDULE_FAILED = "GET_CLASS_SCHEDULE_FAILED"

export const GET_COUNTRY_CODE_REQUESTED = "GET_COUNTRY_CODE_REQUESTED"
export const GET_COUNTRY_CODE_SUCCESSFUL = "GET_COUNTRY_CODE_SUCCESSFUL"
export const GET_COUNTRY_CODE_FAILED = "GET_COUNTRY_CODE_FAILED"

export const TOGGLE_JOIN_CLASS = "TOGGLE_JOIN_CLASS"

export const PAID_COURSE_ENROLLMENT_REQUESTED =
  "PAID_COURSE_ENROLLMENT_REQUESTED"
export const PAID_COURSE_ENROLLMENT_SUCCESSFUL =
  "PAID_COURSE_ENROLLMENT_SUCCESSFUL"
export const PAID_COURSE_ENROLLMENT_FAILED = "PAID_COURSE_ENROLLMENT_FAILED"

export const PAID_BUNDLE_ENROLLMENT_REQUESTED =
  "PAID_BUNDLE_ENROLLMENT_REQUESTED"
export const PAID_BUNDLE_ENROLLMENT_SUCCESSFUL =
  "PAID_BUNDLE_ENROLLMENT_SUCCESSFUL"
export const PAID_BUNDLE_ENROLLMENT_FAILED = "PAID_BUNDLE_ENROLLMENT_FAILED"

export const GET_DRAGONPAY_PROCESSORS_REQUESTED =
  "GET_DRAGONPAY_PROCESSORS_REQUESTED"
export const GET_DRAGONPAY_PROCESSORS_SUCCESSFUL =
  "GET_DRAGONPAY_PROCESSORS_SUCCESSFUL"
export const GET_DRAGONPAY_PROCESSORS_FAILED = "GET_DRAGONPAY_PROCESSORS_FAILED"

export const SHOW_CONFIRM_MODAL = "SHOW_CONFIRM_MODAL"
export const HIDE_CONFIRM_MODAL = "HIDE_CONFIRM_MODAL"

export const SET_EXAM_AS_SUBMITTED = "SET_EXAM_AS_SUBMITTED"

export const SHOW_PROFILE_PHOTO_MODAL = "SHOW_PROFILE_PHOTO_MODAL"
export const HIDE_PROFILE_PHOTO_MODAL = "HIDE_PROFILE_PHOTO_MODAL"

export const UPDATE_PROFILE_PHOTO_REQUESTED = "UPDATE_PROFILE_PHOTO_REQUESTED"
export const UPDATE_PROFILE_PHOTO_SUCCESSFUL = "UPDATE_PROFILE_PHOTO_SUCCESSFUL"
export const UPDATE_PROFILE_PHOTO_FAILED = "UPDATE_PROFILE_PHOTO_FAILED"

export const GET_WALLET_BALANCE_REQUESTED = "GET_WALLET_BALANCE_REQUESTED"
export const GET_WALLET_BALANCE_SUCCESSFUL = "GET_WALLET_BALANCE_SUCCESSFUL"
export const GET_WALLET_BALANCE_FAILED = "GET_WALLET_BALANCE_FAILED"

export const GET_WALLET_TRANSACTIONS_REQUESTED =
  "GET_WALLET_TRANSACTIONS_REQUESTED"
export const GET_WALLET_TRANSACTIONS_SUCCESSFUL =
  "GET_WALLET_TRANSACTIONS_SUCCESSFUL"
export const GET_WALLET_TRANSACTIONS_FAILED = "GET_WALLET_TRANSACTIONS_FAILED"

export const GET_USER_CLASSES_REQUESTED = "GET_USER_CLASSES_REQUESTED"
export const GET_USER_CLASSES_SUCCESSFUL = "GET_USER_CLASSES_SUCCESSFUL"
export const GET_USER_CLASSES_FAILED = "GET_USER_CLASSES_FAILED"

export const GET_USER_WALLET_NONCE_REQUESTED = "GET_USER_WALLET_NONCE_REQUESTED"
export const GET_USER_WALLET_NONCE_SUCCESSFUL =
  "GET_USER_WALLET_NONCE_SUCCESSFUL"
export const GET_USER_WALLET_NONCE_FAILED = "GET_USER_WALLET_NONCE_FAILED"

export const REGISTER_WALLET_ADDRESS_REQUESTED =
  "REGISTER_WALLET_ADDRESS_REQUESTED"
export const REGISTER_WALLET_ADDRESS_SUCCESSFUL =
  "REGISTER_WALLET_ADDRESS_SUCCESSFUL"
export const REGISTER_WALLET_ADDRESS_FAILED = "REGISTER_WALLET_ADDRESS_FAILED"

export const VERIFY_WALLET_ADDRESS_REQUESTED = "VERIFY_WALLET_ADDRESS_REQUESTED"
export const VERIFY_WALLET_ADDRESS_SUCCESSFUL =
  "VERIFY_WALLET_ADDRESS_SUCCESSFUL"
export const VERIFY_WALLET_ADDRESS_FAILED = "VERIFY_WALLET_ADDRESS_FAILED"

export const CLAIM_TOKENS_REQUESTED = "CLAIM_TOKENS_REQUESTED"
export const CLAIM_TOKENS_SUCCESSFUL = "CLAIM_TOKENS_SUCCESSFUL"
export const CLAIM_TOKENS_FAILED = "CLAIM_TOKENS_FAILED"

export const SET_WALLET_CONNECTED = "SET_WALLET_CONNECTED"
export const SET_VERIFYING_ADDRESS = "SET_VERIFYING_ADDRESS"

export const GET_PH_REGIONS_REQUESTED = "GET_PH_REGIONS_REQUESTED"
export const GET_PH_REGIONS_SUCCESSFUL = "GET_PH_REGIONS_SUCCESSFUL"
export const GET_PH_REGIONS_FAILED = "GET_PH_REGIONS_FAILED"

export const GET_IBP_CHAPTERS_REQUESTED = "GET_IBP_CHAPTERS_REQUESTED"
export const GET_IBP_CHAPTERS_SUCCESSFUL = "GET_IBP_CHAPTERS_SUCCESSFUL"
export const GET_IBP_CHAPTERS_FAILED = "GET_IBP_CHAPTERS_FAILED"

export const GET_COMPLIANCE_PERIOD_REQUESTED = "GET_COMPLIANCE_PERIOD_REQUESTED"
export const GET_COMPLIANCE_PERIOD_SUCCESSFUL =
  "GET_COMPLIANCE_PERIOD_SUCCESSFUL"
export const GET_COMPLIANCE_PERIOD_FAILED = "GET_COMPLIANCE_PERIOD_FAILED"
